import Header from "./components/Header/Header";
import HeroSection from "./components/Sections/HeroSection";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import GalleryPage from "./pages/GalleryPage";
import SuchanaPage from "./pages/SuchanaPage";
import AwasarPage from "./pages/AwasarPage";
import HomePage from "./pages/HomePage";
import DownloadPage from "./pages/DownloadPage";
import KarmachariBibranPage from "./pages/HamroBarePages/KarmachariBibran";
import LekhaSamitiPage from "./pages/HamroBarePages/LekhaSamitiPage";
import ParichayaPage from "./pages/HamroBarePages/ParichayaPage";
import SanchalakSamitiPage from "./pages/HamroBarePages/SanchalakSamitiPage";
import BachatPage from "./pages/SewaharuPages/BachatPage";
import Khatapage from "./pages/SewaharuPages/KhataPage";
import RinPage from "./pages/SewaharuPages/RinPage";
import Footer from "./components/Footer/Footer";
import SamparkPage from "./pages/SamparkPage";

function App() {
  return (
    <div className="app">
      <BrowserRouter>
        <Header />
        <Routes>
          {/* Direct Pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/suchana" element={<SuchanaPage />} />
          <Route path="/awasar" element={<AwasarPage />} />
          <Route path="/download" element={<DownloadPage />} />

          {/* Nested -> HamroBare Pages */}
          <Route path="/parichaya" element={<ParichayaPage />} />
          <Route path="/sanchalak-samiti" element={<SanchalakSamitiPage />} />
          <Route path="/karmachari" element={<KarmachariBibranPage />} />
          <Route path="/lekha-samiti" element={<LekhaSamitiPage />} />

          {/* Nested -> Sewa Haru Pages */}
          <Route path="/khata" element={<Khatapage />} />
          <Route path="/rin" element={<RinPage />} />
          <Route path="/bachat" element={<BachatPage />} />

          {/* Sampark Pages */}
          <Route path="/contact" element={<SamparkPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
